import React from "react";
import "./Spinner-dots.scss";

const SpinnerDots = () => {
  return (
    <div className="spinner-dots">
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
    </div>
  );
};

export default SpinnerDots;
